import { ENDPOINTS } from 'src/constants/endpoints'

import { HANWHA_ORG_ID } from 'src/app/auth/constants/organization'
import type { IMemberInsightProducersResponseDTO } from 'src/app/home/pages/member-insights/domain/contracts/member-insights'
import { http } from 'src/interfaces/http'

export const getMemberInsightProducers =
  async (): Promise<IMemberInsightProducersResponseDTO> => {
    const { data } = await http.get<IMemberInsightProducersResponseDTO>(
      ENDPOINTS.hanwha.memberInsightProducers,
      { params: { org_id: HANWHA_ORG_ID } },
    )
    return data
  }
